import { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, message, Button, Form, Input, notification } from "antd";
import { MailOutlined, SearchOutlined } from "@ant-design/icons";
import { ContentRow } from "../../components/GlobalStyles";
import { BranchCard } from "../Booking/BranchCard";
import { PREPARE_BOOKING_BRANCH, PREPARE_BOOKING_COURTS, CHNAGE_LANGUAGE } from "../../redux/constants";
import Loading from "../../components/Loading";
import api from "../../redux/api/axiosInstance";
import { getAuthState, getBookingState, getAppState } from "../../redux/selectors";


export function ShareBranches(): ReactElement {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { clubId } = useParams<{ clubId: string; }>();
  const [branches, setBranches] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [club, setClub] = useState<any>(undefined);
  const { locale } = useSelector(getAppState);

  useEffect(() => {
    api.post("getBranches", { clubId })
      .then((res) => {
        console.log(res);
        const { allBranchesWithClubsAndCourtsCount, clubData } = res.data;
        setClub(clubData);
        setBranches(allBranchesWithClubsAndCourtsCount);
        setLoading(false);
      })
      .catch((e) => {
        setBranches([]);
        setClub(undefined);
        setLoading(false);
      })
  }, []);

  const onBook = (record: any) => {
    dispatch({
      type: PREPARE_BOOKING_BRANCH,
      payload: { branch: { ...record, clubData: club } },
    });
    api.post("getCourts", { branchId: record.firestoreRef })
      .then((res) => {
        const { courts } = res.data;
        if (courts.length) {
          dispatch({
            type: PREPARE_BOOKING_COURTS,
            payload: { courts },
          });
          history.push(`/share/${clubId}/${record.firestoreRef}/calendar`);
        } else {
          message.error("There is no courts to book.");
        }
      })
      .catch((e) => {
        message.error("Oop! Something went wrong. please try again later!");
      })
  };

  const onChangeLanguage = (code: string) => {
    dispatch({
      type: CHNAGE_LANGUAGE,
      payload: code
    })
    i18n.changeLanguage(code);
  }


  return (
    <ContentRow className="auth-container">
      <div className="landing-language-select-container" style={{ zIndex: 20 }}>
        {/* <Button className="language-selector" onClick={() => history.push("/shop")}>{t("menu.shop")}</Button> */}
        <Button className="language-selector" onClick={() => onChangeLanguage(locale === "en" ? "ar" : "en")}>{t("common.language")}</Button>
        <Button className="language-selector" onClick={() => history.push("/login")}>{t("menu.login")}</Button>
      </div>
      <Col xs={24} sm={20} md={16}>
        <Card>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ justifyContent: "center" }}>
            {club && branches.map((b) => (
              <BranchCard branch={b} onBook={onBook} key={b.branchId} club={club} />
            ))}
          </Row>
        </Card>
      </Col>
      {loading && <Loading />}
    </ContentRow>
  );
}
